module.exports = __webpack_public_path__ + "img/轮圈.SLDPRT.7b64fb9c.jpg";